<div [formGroup]="termGroup()" class="terms-form-term-item">
  <mat-checkbox color="primary" [checked]="selected()" [labelPosition]="'after'" (change)="selectTerm.emit($event.checked)"> </mat-checkbox>
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <input
      #termItemInput
      matInput
      formControlName="term"
      autocomplete="off"
      placeholder="Please type your initial option or copy and paste here"
      (paste)="onPasteTerms($event)"
      (keydown.enter)="$event.preventDefault(); add.emit()"
      (keydown.tab)="$event.preventDefault(); add.emit()"
      (keydown.backspace)="onDeleteTermTyping($event)"
    />
    <div matSuffix class="terms-form-term-item__actions">
      <div class="terms-form-term-item__actions__type">
        <empathy-icon-tooltip [icon]="faCircleQuestion" [color]="'light'" [tooltip]="tooltip"></empathy-icon-tooltip>

        <button
          mat-button
          [color]="termGroup().get('type').value === 'contains' ? 'primary' : 'light'"
          (click)="$event.stopPropagation(); onSetTermType('contains')"
        >
          <span class="fs__sm fw__500">Contains</span>
        </button>

        <button mat-button [color]="termGroup().get('type').value === 'exact' ? 'primary' : 'light'" (click)="$event.stopPropagation(); onSetTermType('exact')">
          <span class="fs__sm fw__500">Exact Match</span>
        </button>
      </div>

      @if (allowDelete()) {
        <button mat-icon-button title="Delete term" (click)="deleteTerm.emit()">
          <fa-icon [icon]="faTrash" color="light"></fa-icon>
        </button>
      }
    </div>
  </mat-form-field>
</div>
